<template>
  <div :class="classes">
    <slot />
  </div>
</template>

<script>
export default {
  props: {
    /**
     * The color of the badge
     */
    color: {
      type: String,
      default: 'green',
      validator: function (value) {
        return ['green', 'gray', 'grey', 'red', 'blue'].indexOf(value) !== -1
      }
    },

    /**
     * The nice-name size option for the badge
     */
    size: {
      type: String,
      default: 'default',
      validator: function (value) {
        return ['large', 'default', 'small'].indexOf(value) !== -1
      }
    }
  },

  computed: {
    classes() {
      let baseClasses = ['rounded-md', 'text-center']

      return [...baseClasses, ...this.colorClasses, ...this.sizeClasses]
    },

    colorClasses() {
      switch (this.color) {
        case 'grey':
        case 'gray':
          return ['bg-gray-200', 'text-gray-600']
        case 'red':
          return ['bg-red-200', 'text-red-600']
        case 'blue':
          return ['bg-blue-200', 'text-blue-600']
        case 'green':
        default:
          return ['bg-gray-200', 'text-blue-600']
      }
    },

    sizeClasses() {
      switch (this.size) {
        case 'large':
          return ['py-2', 'px-4', 'text-base']
        case 'small':
          return ['py-0.5', 'px-1', 'text-xs']
        case 'default':
        default:
          return ['py-1', 'px-2', 'text-sm']
      }
    }
  }
}
</script>
